import { StoreState } from "./index";

export const getReferralRequestStatus = (state: StoreState): string => {
  return state;
};

export const getShareRequestStatus = (state: StoreState): string => {
  return state;
};
